// web/src/store/sseSlice.ts
import type { StateCreator } from 'zustand';

export interface SSESlice {
  sseConnectionLost: boolean;
  sseReconnectFn: (() => void) | null;
  sseSetConnectionLost: (lost: boolean, reconnectFn?: (() => void) | null) => void;
}

export const createSSESlice: StateCreator<SSESlice> = (set) => ({
  sseConnectionLost: false,
  sseReconnectFn: null,
  sseSetConnectionLost: (lost, reconnectFn = null) =>
    set({ sseConnectionLost: lost, sseReconnectFn: lost ? reconnectFn : null }),
});
